// ProtectedLayout.tsx
import React, { useState, useEffect, useCallback } from 'react';
import Sidebar from './Sidebar';
import SupportChatWidget from './SupportChat/SupportChatWidget';

interface ProtectedLayoutProps {
  children: React.ReactNode;
}

const SIDEBAR_STATE_KEY = 'sidebarCollapsed';
const BODY_COLLAPSED_CLASS = 'sidebar-collapsed';

const ProtectedLayout: React.FC<ProtectedLayoutProps> = ({ children }) => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState<boolean>(() => {
    if (typeof window === 'undefined') return false; // на всякий случай
    return localStorage.getItem(SIDEBAR_STATE_KEY) === 'true';
  });

  // сохраняем состояние в localStorage
  useEffect(() => {
    if (typeof window === 'undefined') return;
    localStorage.setItem(SIDEBAR_STATE_KEY, String(sidebarCollapsed));
  }, [sidebarCollapsed]);

  // вешаем/снимаем класс на body
  useEffect(() => {
    if (sidebarCollapsed) {
      document.body.classList.add(BODY_COLLAPSED_CLASS);
    } else {
      document.body.classList.remove(BODY_COLLAPSED_CLASS);
    }

    return () => {
      document.body.classList.remove(BODY_COLLAPSED_CLASS);
    };
  }, [sidebarCollapsed]);

  const handleToggleSidebar = useCallback(() => {
    setSidebarCollapsed(prev => !prev);
  }, []);

  return (
    <>
      <Sidebar
        isCollapsed={sidebarCollapsed}
        onToggle={handleToggleSidebar}
      />

      <div
        className={`main-content ${
          sidebarCollapsed ? 'sidebar-collapsed' : ''
        }`}
      >
        {children}
      </div>

      {/* Виджет чата поддержки — виден на всех защищённых страницах. */}
      <SupportChatWidget />
    </>
  );
};

export default ProtectedLayout;
